import React from "react";
import SectionOne from "./sectionOne";
import SectionTwo from "./sectionTwo";
import SectionThree from "./sectionThree";
import SectionFour from "./sectionFour";
import SectionFive from "./sectionFive";
import SectionSix from "./sectionSix";
import group2 from "../../images/Group (2).png";
import VideoSection from "./videoSection";
import SectionSeven from "./sectionSeven";
const Index = () => {
  return (
    <>
      {/* <SectionOne /> */}
      <VideoSection />
      <SectionTwo />
      <SectionThree />
      <img
        src={group2}
        alt="Right decoration"
        className="absolute right-0 top-4/4 transform -translate-y-1/2 w-16 md:w-44"
      />
      <SectionFour />
      <SectionFive />
      <SectionSix />
      <SectionSeven />
    </>
  );
};

export default Index;
